import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCancel = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 39 36",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M30.478 35.448a8.507 8.507 0 100-17.015 8.507 8.507 0 000 17.015zm3.493-10.604l-2.096 2.096 2.096 2.096a.659.659 0 010 .932l-.465.466a.659.659 0 01-.932 0l-2.096-2.096-2.096 2.096a.659.659 0 01-.932 0l-.466-.466a.659.659 0 010-.932l2.096-2.096-2.096-2.096a.659.659 0 010-.931l.466-.466a.659.659 0 01.932 0l2.096 2.096 2.096-2.096a.659.659 0 01.931 0l.466.466a.659.659 0 010 .931z",
		fill: "#FF2E47"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.993 2.586C8.87 2.586 2.287 9.17 2.287 17.29c0 8.122 6.584 14.705 14.706 14.705.64 0 1.27-.04 1.89-.12a.75.75 0 11.19 1.488c-.681.087-1.376.132-2.08.132-8.95 0-16.206-7.255-16.206-16.205S8.043 1.086 16.993 1.086c7.697 0 13.59 5.021 14.52 12.208l3.519-3.653a.75.75 0 111.08 1.041l-4.684 4.86a.75.75 0 01-1.06.02l-4.86-4.683a.75.75 0 111.04-1.08l3.42 3.295c-.99-6.2-6.141-10.508-12.975-10.508z",
		fill: "#211712"
	})]
});
export default SvgIconCancel;
